/* Component Dependencies */
var offerNextGenMpoFilterDropdownsTemplate = require('templates/offerNextGenFilterDropdowns.hbs');
var AriesComponent = require('libs/aries-component');
var PubSub = require('libs/pub-sub');
var $ = require('jquery');

AriesComponent.create({
  type: 'offerNextGenFilterDropdowns',
  template: {
    'offerNextGenFilterDropdowns': offerNextGenMpoFilterDropdownsTemplate
  },
  subscribe: {
    'UPDATE_MPO_DROPDOWN_FILTERS': 'updateDropdowns'
  },
  events: {
    'click .js-toggle-dropdown': 'toggleDropdown',
    'click .js-opt-selected': 'filterOptionSelected',
    'click .js-show-btn': 'resetDropdowns',
    'click .js-toggle-view': 'openFiltersTakeover',
    'click .js-close-takeover': 'closeFilterTakeover',
    'click .js-clear-all-filters': 'clearAllFilters',
    'click .js-apply-filters': 'applyAllFilters'
  },
  applyAllFilters: function(){
    var _self = this;
    _self.closeFilterTakeover();
    const requestToSend = _self.createMpoRequestData();
    _self.pubsub.publish('UPDATE_MPO_PARTICIPATING_HOTELS',[requestToSend]);
    _self.updateDropdowns(requestToSend);
  },
  bindEvents: function() { 
    var _self = this; 
    $(document).on('click', _.bind(this.closeDropdown, this));
    $(function() {
      _self.preselectDropdowns();
    });
    $(window).on('load', function (event) {
      if($(".mpo-dropdown-filters").data("query-param") === "query-search" || $(".mpo-dropdown-filters").data("no-result") === "noResult") {
        $(".js-show-btn").show();
      }
      else {
        $(".js-show-btn").hide();
      }
      if($(".mpo-dropdown-filters").data("poi-search") === "poiSearch") {
        if($("a.js-selected-state").data("pick-state") === $("span.js-selected-state").text().replace(/\s+/g, " ").trim()) {
          $("a.js-selected-city").attr("disabled", "disabled");
        }
      }
    });
  },
  checkDropdowns: function(dropdown, dropdownValue) {
    var _self = this;
    const countryId = 'selectedCountry';
    const stateId = 'selectedStateProvince';
    const usaLabel = 'USA';
    if(dropdown === countryId) {
      if(dropdownValue === usaLabel) {
        _self.resetSelectedDropdown('state');
        _self.resetSelectedDropdown('city');
        if($("#selectedStateProvince").data("display-state") === "") {
          _self.toggleStateDropdown(true);
        }
        else {
          _self.toggleStateDropdown(false);
        }
      }
      else {
        _self.resetSelectedDropdown('state');
        _self.resetSelectedDropdown('city');
        _self.toggleStateDropdown(false);
      }
    }
    else if (dropdown === stateId) {
      _self.resetSelectedDropdown('city');
    }
  },
  clearAllFilters: function() {
    var _self = this;
    _self.resetDropdowns()
  },
  closeDropdown: function(e) {
    var _self = this;
    var container = $('.m-dropdown-container');
    console.log("e.target.className", e.target.className );
    if(e.target.className !== undefined){
      if(e.target.className.indexOf('js-h-toggle') > -1 || e.target.className.indexOf('js-toggle-container') > -1 || e.target.className.indexOf('t-icon') > -1 || e.target.className.indexOf('js-opt-selected') > -1 || e.target.className.indexOf('js-selected-text') > -1) {
        container.each(function(){
          if($(this).find('.js-toggle-dropdown.is-active').length === 0) {
            $(this).find('.js-toggle-container').slideUp();
          }
        });
      }
      else {
          container.each(function(){
              $(this).find('.js-toggle-container').slideUp();
              $(this).find('.js-toggle-dropdown').removeClass('is-active');
          });
      }
    }
  },
  createMpoRequestData: function() {
    var _self = this;
    var payload = {};
    _self.$el.find('.m-dropdown-container').each(function(index) {
      payload[$(this).attr('id')] = $(this).find('.js-selected-text')[0].dataset.code != undefined ? $(this).find('.js-selected-text')[0].dataset.code : '';
      if ($(this).attr('id') === "selectedCity") {
        //console.log("This CODE", $(this).find('.js-selected-text')[0].dataset.code);
        //console.log("Self Displaycity", $(this).data("display-city"));
        if (($(this).data("display-city") === $(this).find('.js-selected-text')[0].dataset.code) || selectedCountry === "") {
          payload['selectedCity'] = "";
        }
      }
    });
    if(showAllClick) {
      payload['selectedCountry'] = "";
      payload['selectedStateProvince'] = "";
      payload['selectedCity'] = "";
      payload['destinationSelected'] = "";
      payload['showAllTrigger'] = true;
    }
    payload['searchFormRefinement'] = false;
    payload['filterTrigger'] = true;
    let childrenAges = $('.m-mpo-search .js-children-ages').val();
    let roomsCount = $('.m-mpo-search input[name="roomCountBox"]').val();
    roomsCount = parseInt(roomsCount.match(/\d+/)[0]);
    var mpoFormData = {
      'fromDate': $('.m-mpo-search input[name="fromDate"]').val(),
      'toDate': $('.m-mpo-search input[name="toDate"]').val(),
      'lengthOfStay': $('.m-mpo-search .js-stepper-input').text(),
      'roomCount': roomsCount,
      'guestCountBox': $('.m-mpo-search input[name="guestCountBox"]').val(),
      'numAdultsPerRoom': $('.m-mpo-search .js-number-of-adults').html(),
      'childrenCountBox': $('.m-mpo-search input[name="childrenCountBox"]').val(),
      'childrenCount': $('.m-mpo-search .js-number-of-children').html(),
      'childrenAges': childrenAges !== '' ? childrenAges.split(','): [],
      'showAvailableFlag': $('.m-offers-property').data("show-available").toString(),
    };
    const mpoRequestData = Object.assign(payload, mpoFormData);
    return mpoRequestData;
  },
  filterOptionSelected: function(e) {
    e.preventDefault();
    var _self = this;
    $(".js-show-btn").show();
    window.showAllCTA = true;
    window.showAllClick = false;
    window.paginationNumClick = false;
    window.paginationArrowClick = false;
    var dropdownSelected = this.$el.find(e.currentTarget).closest('.m-dropdown-container');
    var dropdownType = dropdownSelected.attr('id');
    var $this = _self.$el.find(e.currentTarget);
    $this.closest('.m-dropdown-container').find('.js-toggle-dropdown').toggleClass('is-active');
    if($this.hasClass('js-opt-label')) {
      return;
    }
    var code = $this.find('.js-h-toggle span')[0].dataset.value;
    var description = $this.find('.js-h-toggle span')[0].dataset.desc;
    var selectedItem = dropdownSelected.find('.js-selected-text')[0];
    selectedItem.dataset.value = description;
    selectedItem.dataset.code = code;
    selectedItem.innerHTML = description;
    if(dropdownType === 'selectedCountry') {
      _self.resetSelectedDropdown('state');
      _self.resetSelectedDropdown('city');
    }
    else if(dropdownType === 'selectedStateProvince') {
      _self.resetSelectedDropdown('city');
    }
    else if (dropdownType === 'selectedCity') {
      if($("#selectedStateProvince").data("display-state") === "") {
        _self.toggleStateDropdown(true);
      }
      else {
        _self.toggleStateDropdown(false);
      }
      if($("#selectedCountry").data("display-country") === "") {
        _self.toggleCountryDropdown(true);
      }
      else {
        _self.toggleCountryDropdown(false);
      }
    }
    const requestToSend = _self.createMpoRequestData();
    _self.updateDropdowns(requestToSend);
    if(_self.$el.hasClass('filter-takeover')) {
      return;
    }
    _self.pubsub.publish('UPDATE_MPO_PARTICIPATING_HOTELS',[requestToSend]);
  },
  resetDropdowns: function(event) {
    var _self = this;
    window.showAllCTA = false;
    window.showAllClick = true;
    window.paginationNumClick = false;
    window.paginationArrowClick = false;
    $(".js-show-btn").hide();
    _self.resetSelectedDropdown('country');
    _self.resetSelectedDropdown('state');
    _self.resetSelectedDropdown('city');
    if(_self.$el.hasClass('filter-takeover')) {
      return;
    }
    const requestToSend = _self.createMpoRequestData();
    this.pubsub.publish('UPDATE_MPO_PARTICIPATING_HOTELS',[requestToSend]);
    this.updateDropdowns(requestToSend);
  },
  toggleElement: function(elem, enableElem) {
    if(enableElem) {
      elem.removeAttr('disabled', 'disabled');
    }
    else {
      elem.attr('disabled', 'disabled');
    }
  },
  openFiltersTakeover: function() {
    var _self = this;
    _self.$el.addClass('filter-takeover');
    $('body').css({'height': '100%', 'overflow-y': 'hidden'});
  },
  closeFilterTakeover: function() {
    var _self = this;
    _self.$el.removeClass('filter-takeover');
    $('body').removeAttr("style");
  },
  preselectDropdowns: function() {
    var _self = this;
    window.paginationNumClick = false;
    window.paginationArrowClick = false;
    $('.m-dropdown-container').each(function(index) {
      var idToUse = $(this).attr('id');
      var item = $(this).find('.js-selected-text')[0];
      var itemHasCode = item.dataset && item.dataset.code && item.dataset.code.length > 0;
      if(idToUse === 'selectedCountry') {
        if(itemHasCode) {
          if(item.dataset.code === 'US') {
            if($("#selectedCountry").data("display-country") === "") {
              _self.toggleCountryDropdown(true);
            }
            else {
              _self.toggleCountryDropdown(false);
            }
            if($("#selectedStateProvince").data("display-state") === "") {
              _self.toggleStateDropdown(true);
            }
            else {
              _self.toggleCityDropdown(false);
              _self.toggleStateDropdown(false);
            }
          }
          else {
            _self.toggleStateDropdown(false);
            _self.toggleCityDropdown(true);
            if($("#selectedCountry").data("display-country") === "") {
              _self.toggleCountryDropdown(true);
            }
            else {
              _self.toggleCountryDropdown(false);
            }
          }
        }
        else {
          _self.toggleStateDropdown(false);
          _self.toggleCityDropdown(false);
        }
      }
      else if(idToUse === 'selectedStateProvince') {
        if(itemHasCode || (_self.$el.find('#selectedCountry .js-selected-text')[0].dataset.code && _self.$el.find('#selectedCountry .js-selected-text')[0].dataset.code != 'US')) {
          if ($(".mpo-dropdown-filters").data("no-auto-complete") !== "no-auto-complete") {
            _self.toggleCityDropdown(true);
          }
          else {
            _self.toggleCityDropdown(false);
          }
        }
        else {
          _self.toggleCityDropdown(false);
        }
      }
      else if(idToUse === 'selectedCity') {
        if(itemHasCode) {
          if($("#selectedStateProvince").data("display-state") === "") {
            if($("#selectedCountry").data("display-country") === "US") {
              _self.toggleStateDropdown(true);
            }
          }
          else {
            _self.toggleStateDropdown(false);
          }
          if($("#selectedCountry").data("display-country") === "") {
            _self.toggleCountryDropdown(true);
          }
          else {
            _self.toggleCountryDropdown(false);
          }
          if($("#selectedCity").data("display-city") === "") {
            _self.toggleCityDropdown(true);
          }
          else {
            _self.toggleCityDropdown(false);
          }
          //_self.toggleCityDropdown(false);
        }
      }
    });
  },
  resetSelectedDropdown: function(dropdownToReset) {
    var _self = this;
    if(dropdownToReset === 'country') {
      var countryEl = _self.$el.find('#selectedCountry .js-selected-text')[0];
      countryEl.dataset.value = countryEl.dataset.defaultheader;
      countryEl.innerHTML = countryEl.dataset.defaultheader;
      countryEl.dataset.code = countryEl.dataset.defaultcode;
    }
    else if(dropdownToReset === 'state') {
      var stateEl = _self.$el.find('#selectedStateProvince .js-selected-text')[0];
      stateEl.dataset.value = stateEl.dataset.defaultheader;
      stateEl.innerHTML = stateEl.dataset.defaultheader;
      stateEl.dataset.code = stateEl.dataset.defaultcode;
    }
    else if(dropdownToReset === 'city') {
      var cityEl = _self.$el.find('#selectedCity .js-selected-text')[0];
      cityEl.dataset.value = cityEl.dataset.defaultheader;
      cityEl.innerHTML = cityEl.dataset.defaultheader;
      cityEl.dataset.code = cityEl.dataset.defaultcode;
    }
  },
  toggleCityDropdown: function(toggleToActive) {
    var _self = this;
    if(toggleToActive) {
      if ($(".mpo-dropdown-filters").data("no-auto-complete") !== "no-auto-complete") {
        _self.$el.find('#selectedCity .js-toggle-dropdown').addClass('is-active').attr("disabled", false);
      }
      else {
        _self.$el.find('#selectedCity .js-toggle-dropdown').removeClass('is-active').attr("disabled", true);
      }
    }
    else {
      _self.$el.find('#selectedCity .js-toggle-dropdown').removeClass('is-active').attr("disabled", true);
    }
  },
  toggleStateDropdown: function(toggleToActive) {
    var _self = this;
    if(toggleToActive) {
      _self.$el.find('#selectedStateProvince .js-toggle-dropdown').addClass('is-active').attr("disabled", false);
    }
    else {
      _self.$el.find('#selectedStateProvince .js-toggle-dropdown').removeClass('is-active').attr("disabled", true);
    }
  },
  toggleCountryDropdown: function(toggleToActive) {
    var _self = this;
    if(toggleToActive) {
      _self.$el.find('#selectedCountry .js-toggle-dropdown').addClass('is-active').attr("disabled", false);
    }
    else {
      _self.$el.find('#selectedCountry .js-toggle-dropdown').removeClass('is-active').attr("disabled", true);
    }
  },
  toggleDropdown: function(e) {
    e.preventDefault();
    window.showAllClick = false;
    if(e.currentTarget.hasAttribute('disabled')) {
      return;
    }
    var _self = this;
    var $this = this.$el.find(e.currentTarget),
      collapsedLabel = this.$el.data('collapsedLabel');
      if(!$this.hasClass('is-active')) {
        $('.js-toggle-dropdown').each(function(){
          if($(this).hasClass('is-active')) {
            $(this).toggleClass('is-active');
          }
        });
      }
      $this.toggleClass('is-active');
      if ($this.hasClass('is-active')) {
        $this.attr('aria-label', _self.$el.data('expandedLabel'));
        //$this.closest('.m-dropdown-container').find('.js-toggle-container').show();
      }
      else {
        $this.attr('aria-label', collapsedLabel);
        //$this.closest('.m-dropdown-container').find('.js-toggle-container').hide();
      }
      $(".js-toggle-container").slideUp();
      $this.next('.js-toggle-container').slideDown();
      e.stopPropagation();
  },
  updateDropdowns(data) {
    var _self = this;
    $(".m-load-result").css('display', 'block');
    $(".js-list-container").css('visibility', 'hidden');
    if(_self.$el.hasClass('filter-takeover')) {
      data.takeoverIsOpen = true;
    }
    this.refresh(data, function() {
      window.$(document).trigger('GLOBAL_ELEMENTS_REINIT.mi-foundation');
      if(data.takeoverIsOpen) {
        _self.openFiltersTakeover();
      }
      if($(".mpo-dropdown-filters").data("poi-search") === "poiSearch") {
        if($("a.js-selected-state").data("pick-state") === $("span.js-selected-state").text().replace(/\s+/g, " ").trim()) {
          $("a.js-selected-city").attr("disabled", "disabled");
        }
      }
      $('.m-dropdown-container').each(function(index) {
        var idToUse = $(this).attr('id');
        if(data[idToUse] != '') {
          var selectedItem = $(this).find('.js-selected-text')[0];
          var useResponseData = (idToUse === 'selectedCountry' && _self.data.destinationList.displayCountry != null) || (idToUse === 'selectedStateProvince' && _self.data.destinationList.displayState != null) || (idToUse === 'selectedCity' && ((_self.data.destinationList.displayCity != null && _self.data.destinationList.cityOptions === null) || data.searchFormRefinement === true));
          console.log("useResponseData", useResponseData);
          if(useResponseData) {
            var itemToUse = idToUse === 'selectedCountry' ? _self.data.destinationList.displayCountry : idToUse === 'selectedStateProvince' ? _self.data.destinationList.displayState : _self.data.destinationList.displayCity;
            if (itemToUse != null) {
              selectedItem.innerHTML = itemToUse.description;
              selectedItem.dataset.value = itemToUse.description;
              selectedItem.dataset.code = itemToUse.code;
            }
            if ((_self.data.destinationList.cityOptions != null || _self.data.destinationList.stateOptions != null || _self.data.destinationList.countryOptions != null)) {
              $(selectedItem).closest('.js-toggle-dropdown').removeAttr("disabled", "disabled");
              //console.log("selectedItem in true", selectedItem);
            }
          }
          else {
            var selectedItemText = $(this).find('li.js-opt-selected a span').filter(function(index, opt) {
              return $(opt).attr('data-value') === data[idToUse];
            })[0];
            selectedItemText = selectedItemText? selectedItemText.dataset.desc : '';
            if(data.searchFormRefinement){
              if(data.destinationLatitude === "") {
                selectedItem.innerHTML = selectedItemText;
                selectedItem.dataset.value = selectedItemText;
                selectedItem.dataset.code = data[idToUse];
                console.log("NOT Lat long search");
              }
              else {
                //console.log("searchFormRefinement", data.searchFormRefinement);
                console.log("default header", selectedItem.dataset.defaultheader);
                selectedItem.innerHTML = selectedItem.dataset.defaultheader;
                console.log("Lat long search");
              }
            }
            else {
              selectedItem.innerHTML = selectedItemText;
              selectedItem.dataset.value = selectedItemText;
              selectedItem.dataset.code = data[idToUse];
            }
            if ((_self.data.destinationList.cityOptions != null || _self.data.destinationList.stateOptions != null || _self.data.destinationList.countryOptions != null)) {
              $(selectedItem).closest('.js-toggle-dropdown').removeAttr("disabled", "disabled");
              //console.log("selectedItem in false", selectedItem);
            }
          }
        }
      });
      _self.preselectDropdowns();
      if(data.searchFormRefinement) {	
        if(data.selectedCountry !== ""){	
          window.showAllCTA = true;
        }	
        else if (data.noDropdownSelected) {
          window.showAllCTA = true;
          console.log("data.noDropdownSelected", data.noDropdownSelected);
        }
        else {	
          window.showAllCTA = false;
        }	
      }
      if(showAllCTA) {
        $(".js-show-btn").show();
        //console.log("showAllCTA", showAllCTA);
      }
      else {
        $(".js-show-btn").hide();
        //console.log("showAllCTA", showAllCTA);
      }
      }, function(error) {
        console.log('search form error ' + error);
    });
  }
});